<template>
  <base-wrapper :loading="loading || formModal.loading || deleteModal.loading || loadingJobStatus">
    <div class="mb-4 flex justify-end gap-2">
      <base-input type="text" :shadow="false" placeholder="Cari nama" debounce v-model="filter.search" @native-input="loadProductCategories" />
      <base-button @click="onOpenCreate">Tambah</base-button>
      <base-button :loading="loadingExport.visible" @click="onExport">
        <Icon
          v-if="!loadingExport.visible"
          icon="heroicons:arrow-down-tray"
          class="h-4 w-4"
        />
        {{ loadingExport.visible ? loadingExport.text : 'Export' }}
      </base-button>
    </div>
    <datatable
      :columns="columns"
      :total="productCategories.meta.page.total"
      :perPage="productCategories.meta.page.perPage"
      :currentPage="productCategories.meta.page.currentPage"
      @pagechanged="onPagechanged"
    >
      <template v-slot:tbody="{ classes }">
        <tr
          v-for="productCategory in productCategories.data"
          :key="productCategory.id"
          :class="[classes.tr, 'bg-white']"
        >
          <td :class="[classes.td]">
            <p class="font-bold text-gray-900">
              {{ productCategory.attributes.code || '-' }}
            </p>
          </td>
          <td :class="[classes.td]">
            {{ productCategory.attributes.name }}
          </td>
          <td :class="[classes.td]">
            <div class="flex gap-1">
              <base-button size="sm" @click="onOpenEdit(productCategory)">Edit</base-button>
              <base-button size="sm" color="danger" @click="onOpenDelete(productCategory)">Hapus</base-button>
            </div>
          </td>
        </tr>
      </template>
    </datatable>

    <base-modal
      :showing="formModal.visible"
      @close="formModal.visible = false"
    >
      <base-card :with-style="false" :title="formModal.id ? 'Edit' : 'Tambah'">
        <hr class="mb-5">
        <form class="space-y-4" @submit.prevent="onSubmitForm">
          <base-input label="Kode" placeholder="VCD" :shadow="false" fullwidth type="text" required v-model="formModal.form.code" />
          <base-input label="Nama" placeholder="VCD/DVD" :shadow="false" fullwidth type="text" required v-model="formModal.form.name" />
          <div class="flex gap-2 justify-end">
            <base-button type="button" color="white" @click="formModal.visible = false">Batal</base-button>
            <base-button>Simpan</base-button>
          </div>
        </form>
      </base-card>
    </base-modal>

    <base-confirm
      :visible="deleteModal.visible"
      icon-type="badge"
      type="danger"
      title="Konfirmasi Hapus Kelompok Barang"
      message="Barang yang terkait akan menjadi tidak memiliki kelompok barang, lanjutkan?"
      confirm-text="Hapus"
      @confirmed="onDelete"
      @close="deleteModal.visible = false"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '../../../../../components/base/BaseModal.vue';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';
import { mapGetters } from 'vuex';
import { downloadFileUrl } from '../../../../../services/utils.service';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    BaseConfirm
  },
  data() {
    return {
      loading: false,
      loadingJobStatus: false,
      loadingExport: {
        visible: false,
        text: null,
      },
      filter: {
        search: null
      },
      productCategories: {
        data: [],
        meta: {
          page: {},
        },
      },
      formModal: {
        visible: false,
        id: null,
        form: {
          code: null,
          name: null
        },
        loading: false
      },
      deleteModal: {
        visible: false,
        id: null,
        loading: false
      }
    };
  },
  computed: {
    ...mapGetters({
      getChannelName: 'auth/getChannelName',
    }),
    columns() {
      return [
        {
          id: 'code',
          name: 'Kode',
        },
        {
          id: 'name',
          name: 'Name',
        },
        {
          id: 'action',
          name: 'Aksi',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert'
    }),
    onPagechanged(page) {
      this.loadProductCategories({
        'page[number]': page,
      });
    },
    async onExport() {
      this.startLoadingExport('Mengirim ke server');

      const [, err] = await this.request(
        `/api/v1/product-categories/-actions/export`,
        {
          method: 'post'
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });

        this.stopLoadingExport();
      } else {
        this.startLoadingExport('Sedang diproses');
      }
    },
    onExportProgress(e) {
      if (e.type === 'App\\Notifications\\ProductCategoryExported') {
        if (e.status === 'failed') {
          this.stopLoadingExport();

          this.createAlert({
            data: 'Gagal mengexport kelompok barang',
            status: 'error',
          });
        } else if (e.status === 'success') {
          this.stopLoadingExport();

          downloadFileUrl(e.file_url, 'kelompok_barang.csv', { blank: true });
        }
      }
    },
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onExportProgress
      );
    },
    async loadProductCategories(params) {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/product-categories', {
        params: {
          'page[size]': 5,
          'filter[search]': this.filter.search,
          sort: '-createdAt',
          ...params,
        },
      });

      if (!error) {
        this.productCategories = res;
      }

      this.loading = false;
    },
    async loadJobStatus() {
      this.loadingJobStatus = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'export_product_categories',
          },
        }
      );

      if (!err) {
        const { running } = res;

        if (running) {
          this.startLoadingExport('Sedang Diproses');
        }
      }

      this.loadingJobStatus = false;
    },
    startLoadingExport(text) {
      this.loadingExport.text = text;
      this.loadingExport.visible = true;
    },
    stopLoadingExport() {
      this.loadingExport.visible = false;
    },
    onOpenCreate() {
      this.formModal.id = null
      this.formModal.form.code = null
      this.formModal.form.name = null
      this.formModal.visible = true
    },
    onOpenEdit(category) {
      this.formModal.id = category.id
      this.formModal.form.code = category.attributes.code
      this.formModal.form.name = category.attributes.name
      this.formModal.visible = true
    },
    onOpenDelete(category) {
      this.deleteModal.id = category.id
      this.deleteModal.visible = true
    },
    async onSubmitForm() {
      this.formModal.loading = true

      const [, err] = await this.request(this.formModal.id ? `/api/v1/product-categories/${this.formModal.id}` : `/api/v1/product-categories`, {
        method: this.formModal.id ? 'patch' : 'post',
        data: {
          data: {
            type: 'product-categories',
            ...(this.formModal.id ? { id: this.formModal.id } : {}),
            attributes: {
              code: this.formModal.form.code,
              name: this.formModal.form.name
            }
          }
        }
      })

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err)
        })
      } else {
        this.formModal.visible = false

        this.loadProductCategories()
        this.createAlert({
          status: 'success',
          data: this.formModal.id ? 'Berhasil memperbarui kelompok barang' :'Berhasil menambahkan kelompok barang'
        })
      }

      this.formModal.loading = false
    },
    async onDelete() {
      this.deleteModal.loading = true

      const [, err] = await this.request(`/api/v1/product-categories/${this.deleteModal.id}`, {
        method: 'delete',
      })

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err)
        })
      } else {
        this.deleteModal.visible = false

        this.loadProductCategories()
        this.createAlert({
          status: 'success',
          data: 'Berhasil menghapus kelompok barang'
        })
      }

      this.deleteModal.loading = false
    },
    removeExportListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onExportProgress
        );
      }
    },
  },
  created() {
    this.loadProductCategories();
    this.loadJobStatus();
    this.addListener()
  },
  beforeRouteLeave(to, from, next) {
    this.removeExportListener();

    next();
  },
};
</script>
